import { useLocalSearchParams } from 'expo-router'
import { GameStatistics } from '@/screens/game-statistics-screen/GameStatistics'
import { GameStatisticsConvex } from '@/screens/game-statistics-convex-screen/GameStatisticsConvex'

export default function () {
  const params = useLocalSearchParams<{ gameId?: string }>()

  // If gameId is provided (from Convex game), use Convex statistics
  if (params.gameId) {
    return <GameStatisticsConvex />
  }

  // Otherwise use legacy statistics
  return <GameStatistics />
}
